import { render, staticRenderFns } from "./SelectedVessel.vue?vue&type=template&id=1fd2a726&scoped=true&"
import script from "./SelectedVessel.vue?vue&type=script&lang=js&"
export * from "./SelectedVessel.vue?vue&type=script&lang=js&"
import style0 from "./SelectedVessel.vue?vue&type=style&index=0&id=1fd2a726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2a726",
  null
  
)

export default component.exports